<template>
	<div class="container-fluid">
		<settings-toolbar title="Compensation Schedule"></settings-toolbar>

		<collective-agreements-component></collective-agreements-component>
	</div>
</template>

<script>
import SettingsToolbar from "./SettingsToolbar"

import CollectiveAgreementsComponent from "../../components/super_components/CollectiveAgreementsComponent"

export default {

	name: 'SettingsCollectiveAgreements',
	components: {
		SettingsToolbar,
		CollectiveAgreementsComponent
	}

}
</script>